<template>
<div>
    <slot />    
</div>
</template>

<script>
export default {
name: 'nitrozen-input-prefix'    
}
</script>

<style lang="less">

</style>
